import Flights from '@/api/flights.js'
import {calculateConnectionStatus, connectionTime} from "@/store/modules/FlightConnectionsHelper";

const state = {
    flightBean: null,
    isLoading: false,
    connectionsTo: {},
    connectionsFrom: {}
}

const getters = {
    flightBean: state => state.flightBean,
    isLoading: state => state.isLoading,
    connectionsTo: state => state.connectionsTo,
    connectionsFrom: state => state.connectionsFrom,
}

const actions = {
    fetchFlightBean({dispatch, commit}, flightId) {
        commit('clearConnections')
        commit('setIsLoading', true)
        Flights.flightConnections(flightId)
            .then(({data}) => {
                dispatch('calculateAndSetFlightData', data)
            }).catch(function (error) {
            dispatch('error', {text: 'flight search request failed', error: error})
        }).finally(() => {
            commit('setIsLoading', false)
        })
    },
    calculateAndSetFlightData({commit},data){
        commit('setFlightBean', data)
        commit('setConnectionsTo', data)
        commit('setConnectionsFrom', data)
    }
}

const mutations = {
    setFlightBean(state, data) {
        state.flightBean = data
    },
    setIsLoading(state, data) {
        state.isLoading = data
    },
    setConnectionsTo(state, flight) {
        const connectionsTo = flight.connectionsTo
        if (connectionsTo && Array.isArray(connectionsTo)) {
            for (let connectionFlight of connectionsTo) {
                connectionFlight.trTime = connectionTime(flight, connectionFlight)
                const connectionStatus = connectionFlight.status ? connectionFlight.status : calculateConnectionStatus(flight, connectionFlight)
                if (connectionStatus) {
                    connectionFlight.status = connectionStatus
                }
            }
            state.connectionsTo = flight.connectionsTo.sort(connectionsComparator)
        }
    },
    setConnectionsFrom(state, flight) {
        const connectionsFrom = flight.connectionsFrom
        if (connectionsFrom && Array.isArray(connectionsFrom)) {
            for (let connectionFlight of connectionsFrom) {
                connectionFlight.trTime = connectionTime(connectionFlight, flight)
                const connectionStatus = connectionFlight.status ? connectionFlight.status : calculateConnectionStatus(connectionFlight, flight)
                if (connectionStatus) {
                    connectionFlight.status = connectionStatus
                }
            }
            state.connectionsFrom = flight.connectionsFrom.sort(connectionsComparator)
        }
    },
    clearConnections(state) {
        state.connectionsTo = {}
        state.connectionsFrom = {}
    }
}

function connectionsComparator(a, b) {
    if (a.trTime < b.trTime) {
        return -1;
    }
    if (a.trTime > b.trTime) {
        return 1;
    }
    return 0;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}